// import { useEffect, useRef, useState, useCallback } from "react";

// /**
//  * Bybit SPOT (WS v5)
//  * WS: wss://stream.bybit.com/v5/public/spot
//  * Topics:
//  *  - orderbook.50.{SYMBOL}  (snapshot + delta)
//  *  - tickers.{SYMBOL}
//  */
// export const useBybitSpot = (symbol) => {
//   const [isConnected, setIsConnected] = useState(false);
//   const [error, setError] = useState(null);
//   const [tickerData, setTickerData] = useState(null); // { lastPrice, volume/volume24, bid, ask }
//   const [orderBook, setOrderBook] = useState({ asks: [], bids: [] });

//   const wsRef = useRef(null);
//   const pingTimerRef = useRef(null);
//   const animationFrameRef = useRef(null);

//   const orderBookRef = useRef({ asks: [], bids: [] });
//   const hasSnapshotRef = useRef(false);

//   const DEPTH = 50; // корректная глубина для spot/linear
//   const log = (...a) => console.log("🟨 [BYBIT SPOT]", ...a);

//   const toPairs = (levels) => {
//     if (!Array.isArray(levels)) return [];
//     return levels.map(([p, q]) => [String(p), String(q)]);
//   };

//   const applyDeltas = useCallback((levels, side) => {
//     const base = [...orderBookRef.current[side]];

//     levels.forEach(([price, qty]) => {
//       const pn = parseFloat(price);
//       const qn = parseFloat(qty);
//       const idx = base.findIndex(([p]) => parseFloat(p) === pn);

//       if (qn === 0) {
//         if (idx !== -1) base.splice(idx, 1);
//       } else {
//         if (idx !== -1) base[idx] = [price, qty];
//         else base.push([price, qty]);
//       }
//     });

//     orderBookRef.current[side] =
//       side === "asks"
//         ? base.sort((a, b) => parseFloat(a[0]) - parseFloat(b[0])).slice(0, 20)
//         : base.sort((a, b) => parseFloat(b[0]) - parseFloat(a[0])).slice(0, 20);

//     if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
//     animationFrameRef.current = requestAnimationFrame(() => {
//       setOrderBook({ ...orderBookRef.current });
//     });
//   }, []);

//   const subscribeAll = useCallback((ws, instId) => {
//     const args = [`orderbook.${DEPTH}.${instId}`, `tickers.${instId}`];
//     const msg = { op: "subscribe", args };
//     ws.send(JSON.stringify(msg));
//     log("→ SUB", msg);
//   }, []);

//   const unsubscribeAll = useCallback((ws, instId) => {
//     try {
//       const args = [`orderbook.${DEPTH}.${instId}`, `tickers.${instId}`];
//       ws?.send(JSON.stringify({ op: "unsubscribe", args }));
//       log("→ UNSUB", args);
//     } catch {}
//   }, []);

//   const handleMessage = useCallback((event) => {
//     try {
//       if (typeof event.data !== "string") return;

//       if (event.data === "pong") return;

//       const m = JSON.parse(event.data);

//       // лог ошибок/подтверждений
//       if (m.op === "subscribe" || m.op === "unsubscribe" || m.success !== undefined) {
//         log("evt:", m.op ?? "msg", m.success, m.ret_msg ?? "", m.ret_code ?? "", m.request ?? "");
//       }

//       if (m.topic?.startsWith?.("tickers.")) {
//         const d = Array.isArray(m.data) ? m.data[0] : m.data;
//         if (!d) return;
//         setTickerData((prev) => ({
//           ...(prev || {}),
//           symbol: d.symbol,
//           lastPrice: d.lastPrice ?? prev?.lastPrice,
//           volume: d.volume24h ?? prev?.volume,
//           volume24: d.volume24h ?? prev?.volume24,
//           bid: d.bidPrice,
//           ask: d.askPrice,
//         }));
//         return;
//       }

//       if (m.topic?.startsWith?.("orderbook.")) {
//         const data = Array.isArray(m.data) ? m.data[0] : m.data;
//         if (!data) return;

//         const asks = toPairs(data.a || []);
//         const bids = toPairs(data.b || []);

//         if (m.type === "snapshot" || !hasSnapshotRef.current || data.u === 1) {
//           orderBookRef.current = {
//             asks: asks.sort((x, y) => parseFloat(x[0]) - parseFloat(y[0])).slice(0, 20),
//             bids: bids.sort((x, y) => parseFloat(y[0]) - parseFloat(x[0])).slice(0, 20),
//           };
//           setOrderBook({ ...orderBookRef.current });
//           hasSnapshotRef.current = true;
//           log("📊 snapshot set. asks/bids:", asks.length, bids.length);
//           return;
//         }

//         // delta
//         if (asks.length) applyDeltas(asks, "asks");
//         if (bids.length) applyDeltas(bids, "bids");
//         return;
//       }
//     } catch (e) {
//       log("❌ parse error:", e);
//     }
//   }, [applyDeltas]);

//   useEffect(() => {
//     if (!symbol) return;

//     const instId = symbol.includes("USDT") ? symbol : `${symbol}USDT`;

//     setIsConnected(false);
//     setError(null);
//     setTickerData(null);
//     setOrderBook({ asks: [], bids: [] });
//     orderBookRef.current = { asks: [], bids: [] };
//     hasSnapshotRef.current = false;

//     const ws = new WebSocket("wss://stream.bybit.com/v5/public/spot");
//     wsRef.current = ws;

//     ws.onopen = () => {
//       log("🔗 open:", instId);
//       setIsConnected(true);
//       subscribeAll(ws, instId);

//       // heartbeat: JSON ping
//       pingTimerRef.current = setInterval(() => {
//         try { ws.send(JSON.stringify({ op: "ping" })); } catch {}
//       }, 30000);
//     };

//     ws.onmessage = handleMessage;

//     ws.onerror = (e) => {
//       log("❌ ws error:", e);
//       setError(e?.message || "WS error");
//       setIsConnected(false);
//     };

//     ws.onclose = () => {
//       log("🔌 close");
//       setIsConnected(false);
//     };

//     return () => {
//       try {
//         unsubscribeAll(ws, instId);
//         ws.close();
//       } catch {}
//       if (pingTimerRef.current) { clearInterval(pingTimerRef.current); pingTimerRef.current = null; }
//       if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
//       wsRef.current = null;
//     };
//   }, [symbol, subscribeAll, unsubscribeAll, handleMessage]);

//   return { isConnected, error, orderBook, tickerData };
// };
/* eslint-disable max-len */
import { useEffect, useRef, useState, useCallback } from "react";

const REGION = String(process.env.REACT_APP_BYBIT_REGION || "").toLowerCase();
const WS_CANDIDATES = (() => {
  const core = [
    "wss://stream.bybit.com/v5/public/spot",
    "wss://stream.bybit-aws.com/v5/public/spot",
    "wss://ws.bybit.com/v5/public/spot",
    "wss://stream.bytick.com/v5/public/spot",
  ];
  if (REGION === "tr") core.unshift("wss://stream.bybit-tr.com/v5/public/spot");
  if (REGION === "kz") core.unshift("wss://stream.bybit.kz/v5/public/spot");
  if (REGION === "georgia") core.unshift("wss://stream.bybitgeorgia.ge/v5/public/spot");
  return core;
})();

function pickFirstWorkingWs(urls, timeoutMs = 2500) {
  return new Promise((resolve, reject) => {
    let resolved = false;
    const sockets = [];
    const timers = [];

    const finish = (url, keep) => {
      if (resolved) return;
      resolved = true;
      sockets.forEach(s => { try { if (s !== keep) s.close(); } catch{} });
      timers.forEach(t => clearTimeout(t));
      resolve(url);
    };

    urls.forEach(url => {
      try {
        const ws = new WebSocket(url);
        sockets.push(ws);
        ws.onopen = () => finish(url, ws);
        ws.onerror = () => {};
        const t = setTimeout(() => { try { ws.close(); } catch{} }, timeoutMs);
        timers.push(t);
      } catch {}
    });

    setTimeout(() => { if (!resolved) reject(new Error("No Bybit SPOT WS reachable")); }, timeoutMs + 300);
  });
}

/**
 * Bybit SPOT (WS v5)
 * Topics: orderbook.50.{SYMBOL}, tickers.{SYMBOL}
 */
export const useBybitSpot = (symbol, { fallbackPolling = false } = {}) => {
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);
  const [tickerData, setTickerData] = useState(null);
  const [orderBook, setOrderBook] = useState({ asks: [], bids: [] });

  const wsRef = useRef(null);
  const pingTimerRef = useRef(null);
  const pollTimerRef = useRef(null);
  const animationFrameRef = useRef(null);

  const orderBookRef = useRef({ asks: [], bids: [] });
  const hasSnapshotRef = useRef(false);
  const lastPickedUrlRef = useRef("");

  const DEPTH = 50;
  const log = (...a) => console.log("🟨 [BYBIT SPOT]", ...a);

  const toPairs = (levels) => (Array.isArray(levels) ? levels.map(([p, q]) => [String(p), String(q)]) : []);

  const applyDeltas = useCallback((levels, side) => {
    const base = [...orderBookRef.current[side]];
    levels.forEach(([price, qty]) => {
      const pn = parseFloat(price);
      const qn = parseFloat(qty);
      const idx = base.findIndex(([p]) => parseFloat(p) === pn);
      if (qn === 0) { if (idx !== -1) base.splice(idx, 1); }
      else { if (idx !== -1) base[idx] = [price, qty]; else base.push([price, qty]); }
    });
    orderBookRef.current[side] =
      side === "asks"
        ? base.sort((a,b)=>parseFloat(a[0])-parseFloat(b[0])).slice(0,20)
        : base.sort((a,b)=>parseFloat(b[0])-parseFloat(a[0])).slice(0,20);

    if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
    animationFrameRef.current = requestAnimationFrame(() => setOrderBook({ ...orderBookRef.current }));
  }, []);

  const subscribeAll = useCallback((ws, instId) => {
    const args = [`orderbook.${DEPTH}.${instId}`, `tickers.${instId}`];
    const msg = { op: "subscribe", args };
    ws.send(JSON.stringify(msg));
    log("→ SUB", { url: lastPickedUrlRef.current, args });
  }, []);

  const unsubscribeAll = useCallback((ws, instId) => {
    try {
      const args = [`orderbook.${DEPTH}.${instId}`, `tickers.${instId}`];
      ws?.send(JSON.stringify({ op: "unsubscribe", args }));
      log("→ UNSUB", args);
    } catch {}
  }, []);

  const handleMessage = useCallback((event) => {
    try {
      if (typeof event.data !== "string") return;
      if (event.data === "pong") return;
      const m = JSON.parse(event.data);

      if (m.op === "subscribe" || m.op === "unsubscribe" || m.success !== undefined) {
        log("evt:", m.op ?? "msg", m.success, m.ret_msg ?? "", m.ret_code ?? "", m.request ?? "");
      }

      if (m.topic?.startsWith?.("tickers.")) {
        const d = Array.isArray(m.data) ? m.data[0] : m.data;
        if (!d) return;
        setTickerData((prev) => ({
          ...(prev || {}),
          symbol: d.symbol,
          lastPrice: d.lastPrice ?? prev?.lastPrice,
          volume: d.volume24h ?? prev?.volume,
          volume24: d.volume24h ?? prev?.volume24,
          bid: d.bidPrice,
          ask: d.askPrice,
        }));
        return;
      }

      if (m.topic?.startsWith?.("orderbook.")) {
        const data = Array.isArray(m.data) ? m.data[0] : m.data;
        if (!data) return;

        const asks = toPairs(data.a || []);
        const bids = toPairs(data.b || []);

        if (m.type === "snapshot" || !hasSnapshotRef.current || data.u === 1) {
          orderBookRef.current = {
            asks: asks.sort((x,y)=>parseFloat(x[0])-parseFloat(y[0])).slice(0,20),
            bids: bids.sort((x,y)=>parseFloat(y[0])-parseFloat(x[0])).slice(0,20),
          };
          setOrderBook({ ...orderBookRef.current });
          hasSnapshotRef.current = true;
          log("📊 snapshot set. asks/bids:", asks.length, bids.length, "via", lastPickedUrlRef.current);
          return;
        }

        if (asks.length) applyDeltas(asks, "asks");
        if (bids.length) applyDeltas(bids, "bids");
      }
    } catch (e) {
      log("❌ parse error:", e);
    }
  }, [applyDeltas]);

  useEffect(() => {
    if (!symbol) return;

    const instId = symbol.includes("USDT") ? symbol : `${symbol}USDT`;

    setIsConnected(false);
    setError(null);
    setTickerData(null);
    setOrderBook({ asks: [], bids: [] });
    orderBookRef.current = { asks: [], bids: [] };
    hasSnapshotRef.current = false;

    let closed = false;

    (async () => {
      let url = null;
      try {
        url = await pickFirstWorkingWs(WS_CANDIDATES, 2500);
        lastPickedUrlRef.current = url;
      } catch (e) {
        setError("WS not reachable");
        if (!fallbackPolling) return;
      }
      if (closed) return;

      if (url) {
        const ws = new WebSocket(url);
        wsRef.current = ws;

        ws.onopen = () => {
          log("🔗 open:", instId, "via", url);
          setIsConnected(true);
          subscribeAll(ws, instId);
          pingTimerRef.current = setInterval(() => {
            try { ws.send(JSON.stringify({ op: "ping" })); } catch {}
          }, 20000);
        };

        ws.onmessage = handleMessage;

        ws.onerror = (e) => {
          log("❌ ws error:", e);
          setError(e?.message || "WS error");
          setIsConnected(false);
        };

        ws.onclose = () => {
          log("🔌 close");
          setIsConnected(false);
        };
      } else if (fallbackPolling) {
        // тут можно включить твой REST-пуллинг стакана/тикера (опционально)
      }
    })();

    return () => {
      closed = true;
      const ws = wsRef.current;
      try { if (ws) unsubscribeAll(ws, instId); } catch {}
      try { if (ws) ws.close(); } catch {}
      wsRef.current = null;

      if (pingTimerRef.current) { clearInterval(pingTimerRef.current); pingTimerRef.current = null; }
      if (pollTimerRef.current) { clearInterval(pollTimerRef.current); pollTimerRef.current = null; }
      if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
    };
  }, [symbol, subscribeAll, unsubscribeAll, handleMessage, fallbackPolling]);

  return { isConnected, error, orderBook, tickerData, pickedWsUrl: lastPickedUrlRef.current };
};
